<template>
  <div wrap class="pa-3">
    <v-card flat class="mb-4">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small v-if="false && selectedUser && selectedUser.isMember" color="terciary">{{
          $t('message.purchase_membership') }}</v-btn>
      </v-card-actions>
      <v-card-title>
        <v-autocomplete ref="users_autocomplete" :search-input.sync="emailFilter" v-model="email" :items="users"
          outlined dense item-text="displayName" hide-details item-value="email" :label="$t('message.type_email')">
          <template slot="no-data">
            <v-list-item class="pa-1" @click="selectEmail()">
              <span class="subheading">{{ $t('message.or_use_this_email') }}: </span>
              <v-chip label small>
                {{ emailFilter }}
              </v-chip>
              <v-icon v-if="validEmail" color="green">check_circle_outline</v-icon>
              <v-icon v-else color="error">highlight_off</v-icon>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-card-title>
      <div v-if="email" class="text-center pa-2">
        <v-chip color="primary" outlined>
          <span class="mr-2">{{ this.email }}</span>
          <v-btn color="primary" fab icon small @click="email = null"><v-icon>highlight_off</v-icon></v-btn>
        </v-chip>
      </div>
      <v-expand-transition>
        <div>
          <v-row>
            <v-col>
              <v-card elevation="0">
                <v-card-actions class="mx-4">
                  <v-spacer></v-spacer>
                  <v-btn @click="creditPurchase()" v-if="cardReady && (email || selectedUser) && !sellingMembership"
                    elevation="0" :disabled="cartTotal <= 0" color="primary"><v-icon class="mr-1">credit_card</v-icon>
                    {{ $t('message.card') }}
                  </v-btn>
                  <v-btn @click="cashPurchase()" :disabled="!cartItems || cartItems.length <= 0" elevation="0"
                    color="primary">
                    <v-icon class="mr-1">money</v-icon>
                    {{ $t('message.cash') }}
                  </v-btn>
                  <v-btn v-if="cartTotal > 0 && paymentsReady" @click="openQrCodeDialog()" color="primary"
                    elevation="0">
                    <v-icon class="mr-1">qr_code</v-icon>
                    {{ $t('message.scan') }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-alert v-if="messages && messages != $t('message.success')" type="error">{{ messages }}</v-alert>
          <v-alert v-else-if="messages" type="success">{{ messages }}</v-alert>
          <v-row v-show="showProducts">
            <v-col cols="12" sm="6">
              <v-expansion-panels v-model="productsPanels">
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <div>
                      <v-icon class="mr-1">mdi-cart-outline</v-icon>{{ $t('message.goods') }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-actions class="pa-0">
                      <v-spacer></v-spacer>
                      <v-btn elevation="0" small @click="listSelector = 'category'"
                        :disabled="listSelector == 'category'">
                        <v-icon class="mr-1">mdi-file-tree</v-icon>
                        {{
                          $t('message.categories') }}</v-btn>
                      <v-btn elevation="0" small @click="listSelector = 'list'" :disabled="listSelector == 'list'">
                        <v-icon class="mr-1">mdi-format-list-bulleted</v-icon>{{
                          $t('message.list')
                        }}</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                    <div v-if="listSelector == 'category'">
                      <v-list subheader>
                        <div v-if="popularItems">
                          <v-subheader>{{ $t('message.popular_items') }}</v-subheader>
                          <template v-for="(p) in popularItems">
                            <v-list-item @click="doNothing" :key="'academy_popular_product_by_cat_' + p._id">
                              <v-list-item-avatar>
                                <ImageDisplay v-if="p.image" :src="p.image"></ImageDisplay>
                                <v-img v-else src="@/assets/logo_circular.png"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title><span><b>{{ currency }}{{ p.amountDecimal }}</b></span><span
                                    class="ml-1">{{ p.name }}</span></v-list-item-title>
                                <v-list-item-subtitle>{{ p.category }}</v-list-item-subtitle>
                                <v-list-item-subtitle v-if="p.size">{{ $t('message.size') }}: {{ p.size
                                }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn icon color="primary" @click="addProduct(p)">
                                  <v-icon>add_shopping_cart</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </template>
                        </div>
                        <template v-for="(c, index) in productCategories">
                          <div :key="'academy_product_category' + index">
                            <v-subheader>{{ c }}</v-subheader>
                            <template v-for="(p) in productsByCategory[c]">
                              <v-list-item @click="doNothing" :key="'academy_product_by_cat_' + p._id">
                                <v-list-item-avatar>
                                  <ImageDisplay v-if="p.image" :src="p.image"></ImageDisplay>
                                  <v-img v-else src="@/assets/logo_circular.png"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title><span><b>{{ currency }}{{ p.amountDecimal }}</b></span><span
                                      class="ml-1">{{ p.name }}</span></v-list-item-title>
                                  <v-list-item-subtitle>{{ p.category }}</v-list-item-subtitle>
                                  <v-list-item-subtitle v-if="p.size">{{ $t('message.size') }}: {{ p.size
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-btn icon color="primary" @click="addProduct(p)">
                                    <v-icon>add_shopping_cart</v-icon>
                                  </v-btn>
                                </v-list-item-action>
                              </v-list-item>
                            </template>
                          </div>
                        </template>
                      </v-list>
                    </div>
                    <div v-else>
                      <template v-for="(p) in products">
                        <v-list-item @click="doNothing" :key="'academy_product_' + p._id">
                          <v-list-item-avatar>
                            <ImageDisplay v-if="p.image" :src="p.image"></ImageDisplay>
                            <v-img v-else src="@/assets/logo_circular.png"></v-img>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title><span><b>{{ currency }}{{ p.amountDecimal }}</b></span><span
                                class="ml-1">{{ p.name }}</span></v-list-item-title>
                            <v-list-item-subtitle>{{ p.category }}</v-list-item-subtitle>
                            <v-list-item-subtitle v-if="p.size">{{ $t('message.size') }}: {{ p.size
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon color="primary" @click="addProduct(p)">
                              <v-icon>add_shopping_cart</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-if="hasMemberships">
                  <v-expansion-panel-header>
                    <div>
                      <v-icon :color="!displayMemberships ? 'error' : ''"
                        class="mr-1">mdi-ticket-confirmation-outline</v-icon>{{
                          $t('message.entry_packages') }}
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-if="displayMemberships">
                      <template v-for="(p) in memberships">
                        <v-list-item @click="doNothing" :key="'academy_entrypackage_' + p._id">
                          <v-list-item-avatar>
                            <ImageDisplay v-if="p.image" :src="p.image"></ImageDisplay>
                            <v-icon>mdi-ticket-confirmation-outline</v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title v-html="p.name"></v-list-item-title>
                            <v-list-item-subtitle>{{ currency }}{{ p.amountDecimal }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon color="primary" @click="addProduct(p, true)">
                              <v-icon>add_shopping_cart</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </div>
                    <div v-else class="text-center text-h6 pl-2 pr-2">
                      <div>
                        <v-icon color="error" size="40">mdi-alert</v-icon>
                      </div>
                      {{ $t('message.type_select_entry_package') }}<br>
                      <b>{{ $t('message.waiver_required') }}</b>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12" sm="6">
              <v-card elevation="0" outlined>
                <v-card-actions class="mx-4">
                  <h3>Total:</h3>
                  <v-spacer></v-spacer>
                  <h1>{{ currency }}{{ cartTotal }}</h1>
                </v-card-actions>
                <v-divider></v-divider>
                <div>
                  <v-list v-if="cartItems && cartItems.length > 0" three-line>
                    <template v-for="(item, index) in cartItems">
                      <v-list-item :key="index + '_' + item._id" :ref="'item_' + index + '_' + item._id">
                        <v-list-item-avatar>
                          <ImageDisplay v-if="item.image" :src="item.image"></ImageDisplay>
                          <v-img v-else src="@/assets/logo_circular.png"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-html="item.name"></v-list-item-title>
                          <v-list-item-subtitle>{{ currency }}{{ item.amountDecimal }}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon>
                            <v-icon color="grey lighten-1" @click="removeProduct(index)">delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                  <div v-else class="text-subtitle-2 text-center pa-2">
                    {{ $t('message.empty_cart') }}
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
    <v-dialog v-model="qrCodeDialog" width="70%">
      <v-card outlined v-if="qrProduct" class="pa-2">
        <v-card-text class="text-center">
          <h2>{{ qrProduct.name }}</h2>
        </v-card-text>
        <v-card-text class="text-center">
          <span style="font-size:40px">
            TOTAL
          </span>
          <span style="font-size:40px">
            {{ qrProduct.currencySymbol }}{{ qrProduct.amountDecimal }}
          </span>
        </v-card-text>
        <v-card-text class="text-center">
          <table style="width: 100%; border-collapse: collapse;">
            <tr>
              <td align="center" style="text-align: center;">
                <div style="display: inline-block;padding: 5px; border: 2px solid darkslategrey; border-radius: 5px;">
                  <vue-qrcode v-if="qrUrl" :text="qrUrl" :size="300" />
                </div>
              </td>
            </tr>
          </table>
          <div style="margin-top:-10px" class="text-overline text-center">{{ $t('message.scan_to_pay') }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn block @click="closeQrCodeDialog()" color="secondary" elevation="0">
            {{ $t('message.close') }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="successDialog" width="70%">
      <v-card outlined class="pa-2">
        <v-card-text class="text-center" v-if="completingPurchase">
          <v-progress-linear indeterminate color="success" height="100">
          </v-progress-linear>
        </v-card-text>
        <v-card-text class="text-center" v-if="!completingPurchase">
          <v-icon size="150" color="success">mdi-check-circle-outline</v-icon>
        </v-card-text>
        <v-card-text class="text-center text-h5 success--text" v-if="!completingPurchase">
          <h1>{{ $t('message.success') }}</h1>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeQrCodeDialog()" color="secondary" small elevation="0">
            {{ $t('message.close') }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import VueQrcode from 'vue-qrcode-component';

export default {
  name: "Waiver",
  data() {
    return {
      status: this.$route.query.status,
      sessionId: this.$route.query.s,
      qrCodeDialog: false,
      loading: false,
      academy: null,
      products: null,
      productsByCategory: null,
      productCategories: [],
      listSelector: 'category',
      allProducts: null,
      memberships: null,
      stripeAccountId: null,
      productsPanelHeight: null,
      cartTotal: 0,
      currency: null,
      currencyCode: null,
      cartItems: [],
      cardReady: false,
      selectedUser: null,
      email: null,
      showProducts: true,
      messages: null,
      users: [],
      emailFilter: null,
      paymentsReady: false,
      validEmail: false,
      qrUrl: null,
      qrProduct: null,
      successDialog: false,
      completingPurchase: false,
      sellingMembership: false,
      displayMemberships: false,
      hasMemberships: false,
      productsPanels: 0,
      popularItems: null
    };
  },
  components: {
    VueQrcode
  },
  created() {
    this.productsPanelHeight = (window.innerHeight - 350);
    if (this.sessionId)
      this.completePurchase(this.sessionId, this.status);
    this.getUsers();
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy)
      .then(response => {
        const data = response.data;
        if (data) {
          this.academy = data;
          this.cartItems = [];
          this.cardReady = data.cardReady;
          this.stripeAccountId = data.stripeAccountId;
          this.currencyCode = data.currency;
        }
      });
    Api()
      .get(
        "admintablet/academy/" +
        this.$store.state.tabletManagedAcademy +
        "/products"
      )
      .then(response => {
        this.loading = false;
        const data = response.data;
        if (data && data.products) {
          this.allProducts = data.products;
          this.currency = data.currencySymbol;
          this.paymentsReady = data.paymentsReady;
          this.fillProducts();
        }
      });
  },
  watch: {
    email: {
      immediate: false,
      handler: function () {
        this.selectUser();
      }
    },
    emailFilter: {
      immediate: false,
      handler: function (val) {
        this.isValidEmail(val)
      }
    },
  },
  methods: {
    openQrCodeDialog() {
      let proceed = false;
      if (this.cartItems && this.cartItems.length == 1) {
        for (const i of this.cartItems) {
          const id = i._id;
          if (i.amountDecimal <= 0) {
            proceed = false;
            break;
          }
          this.qrProduct = i;
          this.qrUrl = 'https://core.bjjlink.com/pub/academy/' + this.academy._id + '/product/' + id + "?processed_by=tablet&email=" + this.email;
          proceed = true;
          console.log('QR CODE: ');
          console.log(this.qrUrl);
          break;
        }
      } else {
        const items = this.setupItems(true);
        if (items) {
          let itemsUrl = "";
          for (const i of items) {
            itemsUrl += '&products=' + i.quantity + "|" + i.product
          }
          this.qrProduct = {
            currencySymbol: this.currency,
            amountDecimal: this.cartTotal,
          };
          this.qrUrl = 'https://core.bjjlink.com/pub/academy/' + this.academy._id + '/product/multiple?' + itemsUrl + "&processed_by=tablet&email=" + this.email;
          console.log('QR CODE: ', this.qrUrl)
          proceed = true;
        }
      }
      if (proceed)
        this.qrCodeDialog = true;

    },
    closeQrCodeDialog() {
      this.qrCodeDialog = false;
      this.successDialog = false;
      this.cartItems = [];
      this.email = null;
      this.cartTotal = 0;
      this.selectedUser = null;
      const vm = this;
      setTimeout(function () {
        vm.back();
      }, 2000);
    },
    fillProducts() {
      this.products = [];
      this.productsByCategory = [];
      this.memberships = [];
      for (const p of this.allProducts) {
        if (!p.isMembership && p.type == 'good')
          this.products.push(p);
        else if (p.isMembership && p.type == 'good')
          this.memberships.push(p);
      }
      if (this.memberships.length)
        this.hasMemberships = true;
      //this.showProducts = true;
      this.products = [...this.products].sort((a, b) => a.name.localeCompare(b.name))
      this.productsByCategory = this.groupByCategory(this.products);
      this.productCategories = Object.keys(this.productsByCategory);
    },
    selectUser() {
      if (this.email) {
        for (const u of this.users) {
          if (u.email == this.email) {
            this.selectedUser = u;
            this.displayMemberships = (u.visitorId && u.userId) || u.isMember ? true : false;
            return;
          }
        }
      } else {
        //this.showProducts = false;
        this.selectedUser = null;
        this.emailFilter = null;
      }
    },
    isValidEmail(val) {
      const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;//eslint-disable-line
      if (val && val != '' && reg.test(val)) {
        this.validEmail = true;
      } else {
        this.validEmail = false;
      }
    },
    selectEmail() {
      if (this.validEmail) {
        this.email = this.emailFilter;
        this.$refs.users_autocomplete.blur();
        for (const u of this.users) {
          if (u.email == this.email) {
            this.selectedUser = u;
            this.displayMemberships = (u.visitorId && u.userId) || u.isMember ? true : false;
            return;
          }
        }
      }
    },
    getUsers() {
      Api()
        .post(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/users?source=all", { filter: this.email }
        )
        .then(response => {
          this.users = response.data.users;
        });
    },
    completePurchase(id, status) {
      this.completingPurchase = true;
      this.successDialog = true;
      Api()
        .patch(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/purchase/complete/session/" +
          id + '/' + status
        )
        .then((response) => {
          if (response && response.data) {
            //this.showProducts = false;
            const vm = this;
            try {
              this.completingPurchase = false;
              if (status == 'cancel') {
                this.messages = this.$t("message.cancelled");
                setTimeout(function () {
                  vm.messages = null;
                  vm.selectedUser = null;
                  vm.cartItems = [];
                  vm.cartTotal = 0;
                  vm.back();
                }, 2000);
              } else {
                this.messages = this.$t("message.success");
                setTimeout(function () {
                  vm.back();
                }, 2000);
              }
            } catch (e) {
              console.log(e);
            }
          }
        });
    },
    cashPurchase() {
      this.completingPurchase = true;
      this.successDialog = true;
      const items = this.setupItems(true);
      let buyer = null;
      if (this.selectedUser && this.selectedUser.userId)
        buyer = this.selectedUser.userId;
      else if (this.selectedUser && this.selectedUser._id)
        buyer = this.selectedUser._id;
      let data = {
        email: this.email,
        buyer: buyer,
        items: this.sellingMembership ? null : items,
        product: this.sellingMembership ? items[0].product : null
      };
      Api()
        .post(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/purchase/cash", data
        )
        .then(response => {
          const data = response.data;
          if (data) {
            this.completingPurchase = false;
            //this.showProducts = false;
            const vm = this;
            try {
              setTimeout(function () {
                vm.navigateTo({ name: 'checkin' });
              }, 2000);
            } catch (e) {
              console.log(e);
            }
          }
        });
    },
    creditPurchase() {
      const items = this.setupItems();
      const data = {
        email: this.email,
        buyer: this.selectedUser && !this.selectedUser.visitor ? this.selectedUser._id : null,
        items: items
      };
      Api()
        .post(
          "admintablet/academy/" +
          this.$store.state.tabletManagedAcademy +
          "/purchase/credit", data
        )
        .then(response => {
          const data = response.data;
          if (data) {
            this.navigateTo({
              name: "striperedirect_session",
              params: { sessionId: data.id },
            });
          }
        }).catch((error) => {
          this.messages = "ERROR";
        });
    },
    setupItems(simplified) {
      let items = [];
      for (const i of this.cartItems) {
        let image = this.userFile(this.academy.image);
        if (i.image) image = this.userFile(i.image);
        if (simplified) {
          items.push({
            quantity: 1,
            product: i._id,
          });
        } else {
          items.push({
            name: i.name,
            description:
              !i.description || i.description == "" ? " " : i.description,
            images: [image],
            amount: i.amount,
            amountDecimal: i.amountDecimal,
            currency: this.currencyCode,
            quantity: 1,
            product: i._id,
          });
        }
      }
      return items;
    },
    confirmUserDisabled() {
      let value = true;
      if (this.email &&
        this.email.length > 5 &&
        this.email.indexOf(".") > 2 &&
        this.email.indexOf('@') > 2) {
        const split = this.email.split('.');
        if (split[1].length >= 1) {
          if (!this.showProducts)
            value = false;
        }
      }
      return value;
    },
    back() {
      this.navigateTo({ name: "checkin" });
    },
    addProduct(p, membership) {
      this.sellingMembership = membership;
      if (membership)
        this.cartItems = [];//If entry, only one at the time
      this.cartItems.unshift(p);
      this.calculateTotal();
    },
    removeProduct(position) {
      this.cartItems.splice(position, 1);
      this.calculateTotal();
    },
    calculateTotal() {
      if (this.cartItems) {
        let total = 0;
        for (const i of this.cartItems) {
          total += i.amountDecimal;
        }
        this.cartTotal = total;
      }
    },
    groupByCategory(items) {
      // First, sort the items array by category
      const popularItems = [];
      //this.$t("message.popular_items")
      const sortedItems = [...items].sort((a, b) =>
        a.category.localeCompare(b.category)
      );

      for (const i of items) {
        if (i.popular)
          popularItems.push(i)
      }

      if (popularItems.length)
        this.popularItems = popularItems;

      // Then build the grouped object in sorted order
      let updatedSortedItems = sortedItems.reduce((acc, item) => {
        const { category } = item;
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
        return acc;
      }, {});
      return updatedSortedItems;
    }
  }
};
</script>
<style scoped>
.product-description {
  height: 80px;
  overflow: hidden;
  border-bottom: 2px solid #f5f5f5;
}

.product-title {
  height: 60px;
  overflow-y: hidden
}

.products-panel {
  overflow-y: auto;
}
</style>
